
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spirits/[...spiritSlug]",
      function () {
        return require("private-next-pages/spirits/[...spiritSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spirits/[...spiritSlug]"])
      });
    }
  